import { Injectable } from '@angular/core';
import {
    ValueMetricLimit,
    ValueMetricLimitServer,
    GetValueMetric,
    ValueMetricTransactionDictionary,
    ValueMetricTransactionQuery,
    ValueMetricTransaction
} from '../../core-data-model/ValueMetrics';
import { ApiService, UserProfileSettingsService } from '../../system-services';
import { ValueMetricsTransformer } from './value-metrics.datatransform';

@Injectable({ providedIn: 'root' })
export class ValueMetricsApiConnect {
    constructor(
        private userProfile: UserProfileSettingsService,
        private api: ApiService,
        private transform: ValueMetricsTransformer
    ) {}

    async getValueMetricLimit(
        valueMetricRequest: GetValueMetric
    ): Promise<ValueMetricLimit> {
        return this.api
            .get<
                ValueMetricLimitServer,
                GetValueMetric
            >(`/api/v1-valuemetrics/companies/${this.userProfile.currentCompany}/valuemetrics`, valueMetricRequest)
            .then(([data]) =>
                this.transform.valueMetricsLimitServerToClient(data)
            );
    }

    async getValueMetrics(): Promise<ValueMetricLimit[]> {
        return this.api
            .get<ValueMetricLimitServer[]>(
                `/api/v1-valuemetrics/companies/${this.userProfile.currentCompany}/valuemetrics/all`
            )
            .then(([data]) =>
                data.map((vm) =>
                    this.transform.valueMetricsLimitServerToClient(vm)
                )
            )
            .then((transformed) => transformed);
    }

    async getValueMetricTransactions(
        valueMetricTransactionRequest: ValueMetricTransactionQuery
    ): Promise<ValueMetricTransaction[]> {
        return this.api
            .get<
                ValueMetricTransactionDictionary,
                ValueMetricTransactionQuery
            >(`/api/v1-valuemetrics/companies/${this.userProfile.currentCompany}/valuemetrics/transactions`, valueMetricTransactionRequest)
            .then(([data]) =>
                this.transform.valueMetricTransactionDictionaryServerToClient(
                    data
                )
            );
    }
}
